import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Customer } from '../models/customer-model';
import {Observable} from "rxjs";
import { HttpParams } from '@angular/common/http';

const routes = {
  customer: (id: number) => `/customer/detail/${id}`,
  customer1: (id: string) => `/customer/detail/${id}`,
  customerEdit: () => `/customer/edit`,
  customerForGuest: () => `/customer/filter/guest`,
  groupCustomerFilter: () => `/customer-groups/filter`,
  getCustomerOfGroup: () => `/customer-groups/get-customer`,
  addCustomerGroup: () => `/customer-groups/add-customer-group`,
  groupCustomerCreate: () => `/customer-groups/create`,
  groupCustomerUpdate: () => `/customer-groups/update`,
  getGroupOfCustomer: () => `/customer-groups/get-group-customer`,
  deleteGroupCustomer: () => `/customer-groups/delete`,
  deleteCustomerInGroup: () => `/customer-groups/delete-customer`,
  deleteCustomerGroup: () => `/customer-groups/delete-customer-group`,
  detailGroupCustomer: () => `/customer-groups/get-by-id`,
  addCustomerToGroup: () => `/customer-groups/add-customer`,
  assignCustomerToGroup: () => `/customer-groups/add-customer-group`,
  filterCustomer: () => `/customer-groups/filter-customer`,
  filterGroupCustomer: () => `/customer-groups/filter-group-customer`,
  filterExportHistory: () => `/customer-groups/export-history/filter`,
  deleteExportHistory: (id: string) => `/customer-groups/export-history/delete-by-id/${id}`,
  createExportExcelHistory: () => `/customer-groups/export-history/create`,
  downloadExcel: (id: string) => `/customer-groups/export-history/download-excel/${id}`,
  getExportHistoryById: (id: string) => `/customer-groups/export-history/get-by-id/${id}`,
  uploadImage: '/customer/enterprise/images',
  imageByPath: (id: string) =>  `/customer/view/image-by-path/${id}`,
  getDetailCustomer: '/anonymous/customer/detail',
  generateOtp: '/anonymous/otp/generate-otp',
  confirmOtp: '/anonymous/confirm-customer-identity',
  rejectIndetify: '/anonymous/reject-customer-identity',
  // attachCustomer: (id: number) => `/customer/attachment/${id},
  //Đồng bộ
  filterSync: '/customer/get-all-sync',
  syncServiceType: '/customer/sync',
  getResultSync: (id: string) =>  `/customer/sync/get-result/${id}`,
  genFileCustomer: '/customer/gen-file-customer'
};

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  customers: Customer[];
  // createSuccess = new Subject();

  constructor(
    private apiService: ApiService
  ) { }

  genFileCustomer(body: any) {
    return this.apiService.post(routes.genFileCustomer, body)
    .pipe(map(res => {
      return res;
    }));
  }

  getDetailCustomer(body: any) {
    return this.apiService.post(routes.getDetailCustomer, body)
      .pipe(map(res => {
        return res;
      }));
  }

  generateOtp(body: any) {
    return this.apiService.post(routes.generateOtp, body)
      .pipe(map(res => {
        return res;
      }));
  }

  confirmOtp(body: any) {
    return this.apiService.post(routes.confirmOtp, body)
      .pipe(map(res => {
        return res;
      }));
  }

  rejectIndetify(body: any) {
    return this.apiService.post(routes.rejectIndetify, body)
      .pipe(map(res => {
        return res;
      }));
  }

  getImageByPath(id) {
    return this.apiService.getFile(routes.imageByPath(id))
        .pipe(map(res => {
            return res
        }));
}

  filterCustomers(filter: any) {
    return this.apiService.postSilently('/customer/filter', filter)
      .pipe(map(res => {
        return res;
      }));
  }

  addCustomerToGroup(filter: any) {
    return this.apiService.post(routes.addCustomerToGroup(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  assignCustomerToGroup(filter: any) {
    return this.apiService.post(routes.assignCustomerToGroup(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  addCustomerGroup(filter: any) {
    return this.apiService.post(routes.addCustomerGroup(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  filterCustomerGroups(filter: any) {
    return this.apiService.post(routes.groupCustomerFilter(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  filterGroupCustomer(filter: any) {
    return this.apiService.post(routes.filterGroupCustomer(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  filterCustomer(filter: any) {
    return this.apiService.post(routes.filterCustomer(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  getCustomerOfGroup(body: any) {
    return this.apiService.post(routes.getCustomerOfGroup(), body)
      .pipe(map(res => {
        return res;
      }));
  }

  groupCustomerCreate(body: any) {
    return this.apiService.post(routes.groupCustomerCreate(), body)
      .pipe(map(res => {
        return res;
      }));
  }

  groupCustomerUpdate(body: any) {
    return this.apiService.post(routes.groupCustomerUpdate(), body)
      .pipe(map(res => {
        return res;
      }));
  }

  deleteGroupCustomer(body: any) {
    return this.apiService.post(routes.deleteGroupCustomer(), body)
      .pipe(map(res => {
        return res;
      }));
  }

  deleteCustomerInGroup(body: any) {
    return this.apiService.post(routes.deleteCustomerInGroup(), body)
      .pipe(map(res => {
        return res;
      }));
  }

  deleteCustomerGroup(body: any) {
    return this.apiService.post(routes.deleteCustomerGroup(), body)
      .pipe(map(res => {
        return res;
      }));
  }

  detailGroupCustomer(body: any) {
    return this.apiService.post(routes.detailGroupCustomer(), body)
      .pipe(map(res => {
        return res;
      }));
  }

  getGroupOfCustomer(body) {
    return this.apiService.post(routes.getGroupOfCustomer(), body)
      .pipe(map(res => {
        return res;
      }));
  }

  filterCustomersForGuest(filter: any) {
    return this.apiService.postSilently(routes.customerForGuest(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  createCustomer(customer: any, errCallback?: any) {
    return this.apiService.post('/customer/add', customer)
      .pipe(map(res => {
        if (errCallback && !res.success) errCallback(res);
        return res;
      }));
  }

  uploadImage(body: any){
    return this.apiService.post(routes.uploadImage, body)
      .pipe(map(res => {
        return res;
      }));
  }

  updateCustomer(customer: any, callBack: any, noCallBack: any, errCallback: any) {
    return this.apiService.putAndCheckVersion(
      routes.customerEdit(),
      customer,
      callBack,
      noCallBack,
      errCallback
    );
  }

  getCustomer(id: number) {
    return this.apiService.get(routes.customer(id))
      .pipe(map(res => {
        return res;
      }));
  }

  getCustomer1(id: string) {
    return this.apiService.get(routes.customer1(id))
      .pipe(map(res => {
        return res;
      }));
  }

  // getAttachOfCustomer(id: number) {
  //   return this.apiService.get(routes.attachCustomer(id))
  //     .pipe(map(res => {
  //       return res;
  //     }));
  // }

  deleteCustomer(customerId: number) {
    return this.apiService.get('/customer/delete/' + customerId)
      .pipe(map(res => {
        return;
      }));
  }

  changeBranchStatus(id: number) {
    return this.apiService.get('/enterprises/change-status/' + id)
      .pipe(map(res => {
        return res;
      }));
  }

  getCustomerRegistered(model: any) {
    return this.apiService.post('/auth/receive-customer-information/', model)
      .pipe(map(res => {
        return res;
      }));
  }

  fetchAuto(keyword: string, customerType: string) {
    const res = this.apiService.fetchDataAuto(`/common/auto-complete/customer-certificate?filter=${encodeURIComponent(keyword)}&type=${encodeURIComponent(customerType)}`);
    return res;
  }

  deleteAll(ids: any) {
    return this.apiService.post('/customer/delete-all', ids)
  }


  filterExportHistory(filter: any) {
    return this.apiService.post(routes.filterExportHistory(), filter)
    .pipe(map(res => {
      return res;
    }));
  }

  deleteExportHistory(id: string) {
    return this.apiService.get(routes.deleteExportHistory(id))
    .pipe(map(res => {
      return res;
    }));
  }

  createExportExcelHistory(value: any) {
    return this.apiService.post(routes.createExportExcelHistory(), value)
    .pipe(map(res => {
      return res;
    }));
  }

  downloadExcel(id: string) {
    return this.apiService.getFile(routes.downloadExcel(id))
    .pipe(map(res => {
      return res;
    }));
  }

  getExportHistoryById(id: string) {
    return this.apiService.get(routes.getExportHistoryById(id))
    .pipe(map(res => {
      return res;
    }));
  }
  
  /**
   * Get list service type sync
   * @param filter 
   * @returns 
   */
  filterSyncCustomers(filter: any) {
    return this.apiService.post(routes.filterSync, filter)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Sync service type
   */
   syncCustomers(data: any) {
    return this.apiService.post(routes.syncServiceType, data)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Sync service type
   */
   getResultSyncCustomers(id: string) {
    return this.apiService.get(routes.getResultSync(id))
      .pipe(map(res => {
        return res;
      }));
  }
}
